export default (props) => (
    /**
     * Ícone que faz referencia 
     * a imagem em retrato
     */
    <svg 
        width="21" 
        height="16" 
        viewBox="0 0 21 16" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        >
    <rect 
        x="19.6755" 
        y="14.8984" 
        width="19.0578" 
        height="13.4708" 
        transform="rotate(-180 19.6755 14.8984)" 
        stroke="#C3C3C3"
        />
    <rect 
        x="18.6843" 
        y="13.8984" 
        width="4.36972" 
        height="11.515" 
        transform="rotate(-180 18.6843 13.8984)" 
        fill="#5E5E5E"
        />
    </svg>
  );